import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import ContractForm from './components/contract-form'
// import ContractData from './components/contract-data'
// import Contracts from './components/contracts'
import Medics from './components/medics'
import MedicForm from './components/medics-form'
import Patients from './components/patients'
import PatientsForm from './components/patients-form'
import PatientData from './components/patient-data'
import Profile from './components/profile'
import NuevaCita from './components/nueva-cita'
import Citas from './components/citasPendientes'
import MiRegistro from './components/registroVisitas'
import Hospitalization from './components/hospitalization'
import HospitalizationForm from './components/hospitalization-form'
import HospitalizationTimeline from './components/hospitalization-timeline'
require('gun/sea');
const routes = [
  {
    path: "/visits/new", component: ContractForm, name: "new-visit"
  },
  {
    path: "/citas", component: Citas, name: "citas"
  },
  {
    path: "/hospitalizaciones", component: MiRegistro, name: "mi-registro"
  },
  {
    path: "*",  component: MiRegistro,
  },
  //  {
  //   path: "/visits/:id", component: ContractData, name: 'visit-data'
  // },
  // {
  //   path: "/visits", component: Contracts, name: "visits"
  // },
  {
    path: "/nueva-cita", component: NuevaCita, name: "nueva-cita"
  },
  {
    path: "/medics", component: Medics, name: "medics"
  },
  {
    path: "/medics/new", component: MedicForm, name: "new-medic"
  },
  {
    path: "/patients", component: Patients, name: "patients"
  },
  {
    path: "/patients/new", component: PatientsForm, name: "new-patient"
  },
  {
    path: "/patient/:id", component: PatientData, name: "patient"
  },
  {
    path: "/profile", component: Profile, name: "profile"
  },
  {
    path: "/hospitalization/:id", component: Hospitalization, name: "hospitalization"
  },
  {
    path: "/hospitalization/:id/timeline", component: HospitalizationTimeline, name: "hospitalization-timeline"
  },
  {
    path: "/new-hospitalization", component: HospitalizationForm, name:"new-hospitalization"
  }
]

const router = new VueRouter({routes})
// const ContractManager = require('./managers/visitsManager')

Vue.use(VueRouter)
// ContractManager.CreateProfile()
Vue.config.productionTip = false

new Vue({
  render: h => h(App), router
}).$mount('#app')
